<template>
  <div class="d-flex flex-column flex-grow-1">
    <TopBar
      :backToRoute="backToRoute"
      :backFrameRoute="backFrameRoute"
      :onlyLogoHeader="onlyLogoHeader"
    />
    <v-container
      class="flex-grow-1 main-container"
      :class="[bg, padding, extraClasses]"
    >
      <slot />
    </v-container>
    <BottomBar v-if="!onlyLogoHeader" />
  </div>
</template>

<script>
import TopBar from "@/components/TopBar";
import BottomBar from "@/components/BottomBar";

export default {
  name: "MainLayout",
  props: {
    bg: String,
    backToRoute: [Boolean],
    removePadding: Boolean,
    extraClasses: String,
    onlyLogoHeader: Boolean,
    backFrameRoute: String,
  },
  components: {
    TopBar,
    BottomBar,
  },
  computed: {
    padding() {
      return this.removePadding ? "pa-0" : "px-8";
    },
  },
};
</script>
